import React, { useEffect, useRef, useState } from "react";
import { apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../components/ErrorMessage";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";

const UnionModal = ({
  show,
  onHide,
  getAllUnions,
  editData,
  setPage,
}) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur", shouldFocusError: true, defaultValues: {} });

  useEffect(() => {
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue("name", editData.name ?? "");
      setValue("bnName", editData.bnName ?? "");
    }
  }, [editData]);

  const handleSubmitForm = async (data) => {
    try {
      const res = await apiPut(apiPath.unionEdit + "/" + editData._id, {
        name: data?.name,
        bnName: data?.bnName,
      });
      if (res.data.success === true) {
        getAllUnions();
        onHide();
        notification.success(res.data.message);
      } else {
        notification.error(res?.data.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto">
          <div className="md:py-4 sm:px-2 sm:py-8 px-7">
            <form
              className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[462px]"
              onSubmit={handleSubmit(handleSubmitForm)}
            >
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("EDIT_UNION")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => onHide()}
                >
                  <span
                    className=" text-[#B8BBBF]  text-4xl "
                    title={t("O_CLOSE")}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0   w-full group">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        maxLength={51}
                        {...register("name", {
                          required: t("VALIDATION_NAME_REQUIRED"),
                          validate: (value) => {
                            const val = value.trim();
                            return val.length < 2
                              ? t("VALIDATION_NAME_MIN_LENGTH")
                              : val.length > 50
                              ? t("VALIDATION_NAME_MAX_LENGTH")
                              : true;
                          },
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart();
                          setValue("name", value, { shouldValidate: true });
                        }}
                      />
                      <label
                        htmlFor="name"
                        className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("O_NAME")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.name?.message} />
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0   w-full group">
                      <input
                        type="text"
                        name="bnName"
                        id="bnName"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        maxLength={51}
                        {...register("bnName", {
                          required: t("VALIDATION_NAME_REQUIRED"),
                          validate: (value) => {
                            const val = value.trim();
                            return val.length < 3
                              ? t("VALIDATION_NAME_MIN_LENGTH")
                              : val.length > 50
                              ? t("VALIDATION_NAME_MAX_LENGTH")
                              : true;
                          },
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart();
                          setValue("bnName", value, { shouldValidate: true });
                        }}
                      />
                      <label
                        htmlFor="bnName"
                        className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("O_BN_NAME")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.bnName?.message} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="bg-LightBlue text-white active:bg-emerald-600 font-normal uppercase text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t("O_EDIT")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default UnionModal;
